<template>
  <div class="header">
    <van-nav-bar>
      <template #left>
        <van-icon v-if="safeShowReturn == 1" name="arrow-left" @click="leftClick" size="18" />
      </template>
      <template #title>
        <span>{{ safeTitle }}</span>
      </template>
      <template #right>
        <div v-if="safeIconUrl != -1">
          <img
            v-if="safeIconType == 1"
            :src="safeIconkey"
            style="height: 65%"
            @click="toPage()"
          />
          <van-icon v-else :name="safeIconkey" @click="toPage()" size="24" />
        </div>
        <div v-else>
          <van-icon v-if="safeWapConfig.custom_service && safeWapConfig.custom_service.length > 0" :name="safeIconkey" @click="toPage()" size="24" />
        </div>
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  name: "WebHeader",
  props: ["title", "isreturn", "iconkey", "routerName", "iconurl", "icontype",'showReturn'],
  inject: ["app"],
  computed: {
    safeShowReturn(){
      return this.showReturn || 1
    },
    safeWapConfig() {
      return this.app.wapConfig || {};
    },
    safeIconType() {
      return this.icontype || 1;
    },
    safeTitle() {
      return this.title || "";
    },
    safeIsReturn() {
      return this.isreturn || false;
    },
    safeIconkey() {
      return this.iconkey || null;
    },
    safeRouterName() {
      return this.routerName || null;
    },
    safeIconUrl() {
      return this.iconurl || null;
    },
  },
  mounted(){
  },
  methods: {
    leftClick() {
      if (this.safeRouterName) {
        this.$router.push({ name: this.safeRouterName });
      } else {
        this.$router.back();
      }
    },
    toPage() {
      if (this.safeIconUrl != -1) this.$router.push({ name: this.safeIconUrl });
      else {
        this.jumpUrl(this.safeWapConfig.custom_service);
      }
    },
    jumpUrl(url) {
      console.log(url)
      this.app.show_servers = true
      //window.open(url, '_blank', 'noopener,noreferrer');
      //return;
      /*
      const _u = navigator.userAgent;
      const ios = _u.indexOf("iPhone") > -1;
      const iPad = _u.indexOf("iPad") > -1;
      if (ios || iPad) {
        window.location.replace(url);
      } else {
        if (url.includes("https://")) {
          window.open(url);
        } else {
          window.location.href = url;
        }
      }
        */
    },
  },
};
</script>

<style>
</style>
